import { Parti } from '../../../domain'

const partiOppslutning = {
  R: 2.4,
  SV: 6.0,
  AP: 27.4,
  SP: 10.3,
  MDG: 3.2,
  KRF: 4.2,
  V: 4.4,
  H: 25.0,
  FRP: 15.2,
  ALL: 0.1,
  HEPA: 0.4,
  LIB: 0.2,
  NKP: 0.0,
  DEM: 0.1,
  PDK: 0.3,
  KP: 0.1,
  PIR: 0.1,
  PP: 0.4,
  VERD: 0.0,
  FI: 0.0,
  NMØR: 0.1
}

export function byOppslutning(partyA: Parti, partyB: Parti) {
  const oppslutningA = partiOppslutning[partyA.kortNavn]
  const oppslutningB = partiOppslutning[partyB.kortNavn]

  if (oppslutningA == null && oppslutningB != null) {
    return 1
  }
  if (oppslutningA != null && oppslutningB == null) {
    return -1
  }

  if (oppslutningA == null && oppslutningB == null) {
    if (partyA.navn.nb > partyB.navn.nb) {
      return -1
    }
    if (partyA.navn.nb < partyB.navn.nb) {
      return 1
    }
    return 0
  }

  if (oppslutningA > oppslutningB) {
    return -1
  }
  if (oppslutningB > oppslutningA) {
    return 1
  }
  if (oppslutningA === oppslutningB) {
    return 0
  }

  return 0
}
